/**
 * INSTANT PRICE UPDATE - Hot swap approach
 * 
 * Strategy: Immediately update price text when variant changes, then let Shopify's
 * renderProductInfo() fetch happen in background (for discounts, inventory, etc).
 * This makes the price appear instant while still allowing server-side updates.
 */

(function() {
  let variantData = null;

  // Cache variant data on page load
  function cacheVariantData() {
    const variantSelects = document.querySelector('variant-selects');
    if (!variantSelects) return false;

    const variantDataScript = variantSelects.querySelector('script[type="application/json"]');
    if (!variantDataScript) return false;

    try {
      variantData = JSON.parse(variantDataScript.textContent);
      return true;
    } catch (e) {
      console.error('Failed to parse variant data:', e);
      return false;
    }
  }

  // Format price with currency (matches Shopify format)
  function formatMoney(cents) {
    const dollars = cents / 100;
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(dollars);
  }

  // Hot swap the price text instantly
  function hotSwapPrice(variantId) {
    if (!variantData) return;

    const variant = variantData.find(v => v.id === parseInt(variantId));
    if (!variant) return;

    // Find all price elements (main + sticky)
    const priceElements = document.querySelectorAll('.price ins .amount');
    const compareElements = document.querySelectorAll('.price del');
    
    // Update all price displays instantly
    priceElements.forEach(priceEl => {
      priceEl.textContent = formatMoney(variant.price);
      
      // Handle discount styling
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceEl.classList.add('discounted');
      } else {
        priceEl.classList.remove('discounted');
      }
    });

    // Update compare-at-price
    compareElements.forEach(delWrapper => {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        const delAmount = delWrapper.querySelector('.amount');
        if (delAmount) {
          delAmount.textContent = formatMoney(variant.compare_at_price);
        }
        delWrapper.style.display = '';
      } else {
        delWrapper.style.display = 'none';
      }
    });

    // Show price containers if hidden
    const containers = document.querySelectorAll('[id^="price-"]');
    containers.forEach(container => {
      container.classList.remove('visibility-hidden');
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    if (!cacheVariantData()) return;

    const variantInput = document.querySelector('select[name="id"], input[name="id"]');
    if (!variantInput) return;

    // Intercept changes and hot swap immediately
    variantInput.addEventListener('change', (e) => {
      hotSwapPrice(e.target.value);
    });

    // Also listen via MutationObserver for programmatic changes
    const observer = new MutationObserver(() => {
      if (variantInput.value) {
        hotSwapPrice(variantInput.value);
      }
    });
    
    observer.observe(variantInput, { 
      attributes: true, 
      attributeFilter: ['value'] 
    });
  }
})();
